import { rootURL } from '../constants';
import domWrap from '../utils/domWrap';
import elMaybe from '../utils/elMaybe';
import h from '../utils/htm';
import http from '../utils/http';
import redraw from '../utils/redraw';

export default async body => { // 'body'
	const { default: InputMask } = await import('inputmask');
	const _cookieFbClickId = '_fbp';
	const _urlFbClickId = 'fbclid';
	
	let DealerId,
		StockNumber,
		VIN,
		Portfolio_ID,
		eventData,
		token,
		environment,
		captcha;

	function getCookie(cname) {
		let name = cname + "=";
		let decodedCookie = decodeURIComponent(document.cookie);
		let ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}
	function getSessionID() {
		let tmpSessionID = getCookie('_ga_L6T3WPBPGX');
		let tmpSessionIDArray = tmpSessionID.split(".");
		let tmpSessionIDFinal = "";
		if (tmpSessionID.indexOf('GS2') == 0) {
			tmpSessionIDFinal = tmpSessionIDArray[2].split('$');
			tmpSessionIDFinal = tmpSessionIDFinal[0];
			tmpSessionIDFinal = tmpSessionIDFinal.replace('s', '');
		} else {
			tmpSessionIDFinal = tmpSessionIDArray[2];
		}

		return tmpSessionIDFinal;
	}

	function getClientID() {
		let tmpClientID = getCookie('_ga');
		return tmpClientID.replace('GA1.1.', '');
	}

	const SessionID = getSessionID();
	const ClientID = getClientID();

	domWrap(body).on('click', 'a[call]', function () {
		const closestEData = this.closest('[e-data]')
		const eData = closestEData
			? closestEData.getAttribute('e-data')
			: undefined;
		if (eData && window.dataLayer) {
			window.dataLayer.push(Object.assign({ 'event': 'contactDealer-CallBtn' }, JSON.parse('{' + eData.split("'").join('"') + '}')));
		}
	})
		.on('click', 'button[contact]', function () {
			environment = this.getAttribute('environment');
			captcha = this.getAttribute('captcha');
			const phoneMask = new InputMask('999-999-9999'),
				message = this.getAttribute('message'),
				closestEData = this.closest('[e-data]'),
				eData = closestEData ? closestEData.getAttribute('e-data') : undefined,
				modal = elMaybe('main > comp-modal[contact]', () => h('comp-modal contact',
					h('header',
						h('button class-toggle="modal-active-contact" data-target="html" close')
					)
						('inner-content',
							h('comp-error')
								('label class="contact-label"',
									h('h4', 'Your Message')
										('textarea name="Comments"')
								)
								('label',
									h('h4', 'First Name')
										('input type="text" name="FirstName" required="true"')
								)
								('label',
									h('h4', 'Last Name')
										('input type="text" name="LastName" required="true"')
								)
								('label',
									h('h4', 'Email Address')
										('input type="email" name="Email" required="true"')
								)
								('label',
									h('h4', 'Phone Number')
										('input type="tel" name="Phone" required="true"')
								)
								('label',
									h('input type="checkbox" name="OptIn" required="true"')
										('p', `I agree that Daimler Truck North America and its partners may send me promotional email messages
								with offers, updates and other marketing messages. I understand and agree that
								Daimler Truck North America and its partners may use my information in accordance with its
								<a href="https://northamerica.daimlertruck.com/privacy-policy" target="_blank">Privacy Policy</a>`)
								)
								('label',
									h('div id="captcha_container_contact"')
										('span id="captchamsg" style="color:red"')
								)
						)
						('comp-thankyou',
							h('h2', 'Thank You.')
								('h3', 'WE LOOK FORWARD TO SERVING YOU.')
						)
						('footer',
							h('button class="contact-button" type="submit"', 'Send')
						)
				).Node, 'main');

			window.captchaInstance = undefined;

			if (window.grecaptcha && captcha && captcha !== '') {
				setTimeout(function () {
					window.captchaInstance = grecaptcha.render('captcha_container_contact', {
						'sitekey': captcha
					});
				}, 1000);
			}

			DealerId = this.getAttribute('dealer'),
				StockNumber = this.getAttribute('stock'),
				VIN = this.getAttribute('VIN'),
				Portfolio_ID = this.getAttribute('portfolioid'),
				token = this.getAttribute('token'),
				eventData = eData ? JSON.parse('{' + eData.split("'").join('"') + '}') : false;

			[...modal.querySelectorAll('input[type="tel"]')].forEach(input => phoneMask.mask(input));
			modal.classList.remove('thankyou');
			[...modal.querySelectorAll('textarea')].forEach(textarea => textarea.value = message);

			setTimeout(() => {
				document.querySelector('html').classList.add('modal-active-contact');
				redraw()
			}, 10);

			if (eventData && window.dataLayer) {
				window.dataLayer.push(Object.assign({ 'event': 'contactDealer-EmailBtn' }, eventData));
			}
		})
		.on('click', 'main> comp-modal[contact] button[type="submit"]', function (e) {
			
			var cres = (window.grecaptcha && captcha && captcha !== '')
				? window.grecaptcha.getResponse(window.captchaInstance) : 'valid';
			if (cres.length == 0) {
				document.getElementById('captchamsg').innerHTML = "You can't leave Captcha empty";
				return;
			}
			else {
				document.getElementById('captchamsg').innerHTML = "";
			}

			let fbClickId = $.tb.cookie.getItem(_cookieFbClickId);

			const urlParams = new URLSearchParams(window.location.search);

			if (urlParams.has(_urlFbClickId)) {
				fbClickId = urlParams.get(_urlFbClickId);
			}

			const ip = $.tb.cookie.hasItem('NearestDealerId')
				? JSON.parse($.tb.cookie.getItem('NearestDealerId')).ip
				: '';

			const modal = this.closest('main > comp-modal[contact]'),
				postData = {
					clickId: fbClickId,
					clientIPAddress: ip,
					comments: modal.querySelector('[name="Comments"]')?.value,					
					dealerId: DealerId,
					stockNumber: StockNumber,
					portfolioId: Portfolio_ID,
					email: modal.querySelector('[name="Email"]')?.value,
					firstName: modal.querySelector('[name="FirstName"]')?.value,
					lastName: modal.querySelector('[name="LastName"]')?.value,
					phoneNumber: modal.querySelector('[name="Phone"]')?.value,
					optIn: modal.querySelector('[name="OptIn"]')?.checked ? true : false,
					captcha: cres,
					vin: VIN,
					sTCClientId: ClientID,
					sTCSessionId: SessionID
				},
				required = [...modal.querySelectorAll('[required="true"]')].reduce((arr, input) => {
					if (!input.value) {
						return [...arr, input];
					}
					else {
						return arr;
					}
				}, []);

			e.preventDefault();

			[...modal.querySelectorAll('label')].forEach(label => label.classList.remove('invalid'));

			if (required.length === 0) {
				modal.classList.add('loading');

				const validationToken = { name: '', value: '' };
				const tokenArray = token.split(':');
				if (tokenArray.length === 2) {
					validationToken.name = tokenArray[0];
					validationToken.value = tokenArray[1];
				}

				http(rootURL + '/umbraco/api/DealerContact')
					.createWithJson(postData, validationToken)
					.then(data => {
						
						if (data.isSuccess) {
							modal.classList.add('thankyou');
						}
						else {
							modal.querySelector('comp-error').innerHTMl = data.Message.reduce((html, item) => {
								return html + h('p', item.ErrorMessage).toString();
							}, '');
						}
						modal.classList.remove('loading');
						if (eventData && window.dataLayer) {
							window.dataLayer.push(Object.assign({ 'event': 'contactDealer-EmailSent' }, eventData));
						}
					})
					.catch(() => {
						modal.classList.remove('loading');
						if (eventData && window.dataLayer) {
							window.dataLayer.push(Object.assign({ 'event': 'contactDealer-EmailSent' }, eventData));
						}
					});
			}
			else {
				required.forEach(input => input.closest('label').classList.add('invalid'));
			}
		});

	domWrap(document.querySelector('html:not(.touch) body')).on('click', 'a[call]', function (e) {
		if (!document.querySelector('html').classList.contains('touch')) {			
			if (this.parentNode.classList.contains('expanded'))
				e.preventDefault();
			this.parentNode.classList.toggle('expanded');
		}
	});
};